import React from 'react'
import { string, object, bool, func } from 'prop-types'
import VehicleListingFilterAccordion from '../../VehicleListingFilterAccordion'
import { RadioGroupWrapper } from '../../../utils/style'
import { Flex } from 'rebass'
import RangeInput from './RangeInput'

class PriceAccordion extends React.PureComponent {
  constructor(...args) {
    super(...args)
    this.pricing = {
      full: {
        label: 'Full',
        property: 'value',
        step: 1000,
        prices: this.props.prices.value
      },
      monthly: {
        label: 'Monthly',
        property: 'monthlyPayment',
        step: 100,
        prices: this.props.prices.monthlyPayment
      }
    }
    this.state = {
      changed: false,
      pricing: this.pricing[this.props.pricing] || this.pricing.full,
      values: {
        value: this.props.values.value,
        monthlyPayment: this.props.values.monthlyPayment
      }
    }
    this.handleClear = this.handleClear.bind(this)
    this.handlePricingChange = this.handlePricingChange.bind(this)
    this.onRangeChange = this.onRangeChange.bind(this)
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({
      values: props.values
    })

    if (!props.values.value && props.values.monthlyPayment) {
      this.setState({
        pricing: this.pricing.monthly
      })
    } else if (props.values.value && !props.values.monthlyPayment) {
      this.setState({
        pricing: this.pricing.full
      })
    }
  }

  handleClear() {
    this.props.onPriceChange({ values: { value: null, monthlyPayment: null } })
    this.setState({
      changed: false,
      values: { value: null, monthlyPayment: null }
    })
  }

  handlePricingChange(e) {
    this.setState({
      changed: false,
      values: { value: null, monthlyPayment: null },
      pricing: this.pricing[e.target.value]
    })
    this.props.onPriceChange({ values: { value: null, monthlyPayment: null } })
  }

  onRangeChange(slider) {
    const newValues = {
      ...this.state.values,
      [this.state.pricing.property]: slider.values
    }
    this.setState({
      changed: true,
      values: newValues
    })
    const returnValues = Object.keys(newValues).reduce((values, property) => {
      values[property] = null
      return values
    }, {})
    returnValues[this.state.pricing.property] =
      newValues[this.state.pricing.property]
    this.props.onPriceChange(returnValues)
  }

  render() {
    return (
      <VehicleListingFilterAccordion
        title="Price"
        selected={this.state.changed ? [true] : []}
        onClear={this.handleClear}
      >
        <fieldset>
          {this.props.hasMonthly && (
            <Flex width={[1 / 1]} pt={10} px={12}>
              <RadioGroupWrapper>
                <input
                  type="radio"
                  onChange={this.handlePricingChange}
                  id="price-full"
                  name="price-cost-select"
                  value="full"
                  checked={this.state.pricing.label === 'Full'}
                />
                <label htmlFor="price-full">Full price</label>
              </RadioGroupWrapper>
              <RadioGroupWrapper>
                <input
                  type="radio"
                  onChange={this.handlePricingChange}
                  id="price-monthly"
                  name="price-cost-select"
                  value="monthly"
                  checked={this.state.pricing.label === 'Monthly'}
                />
                <label htmlFor="price-monthly">Monthly</label>
              </RadioGroupWrapper>
            </Flex>
          )}
          <RangeInput
            data={this.state.pricing.prices}
            onChange={this.onRangeChange}
            step={this.state.pricing.step}
            prefix="£"
            values={this.state.values[this.state.pricing.property]}
          />
        </fieldset>
      </VehicleListingFilterAccordion>
    )
  }
}

PriceAccordion.defaultProps = {
  hasMonthly: true,
  values: {},
  pricing: 'full'
}

PriceAccordion.propTypes = {
  hasMonthly: bool,
  pricing: string,
  prices: object.isRequired,
  values: object,
  onPriceChange: func.isRequired
}

export default PriceAccordion
